export default {"src":"/_next/static/media/subjectNew.8cccefa1.svg","height":97,"width":89,"blurWidth":0,"blurHeight":0};